import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSelect from "../../../../components/Select/Select";
import { getVetsSlotsReportData } from "../../../../redux/reducers/reportSlice";
import { w20h20BlueIcon } from "../../../../util/CommonIconStyle";
import { minutesToHours } from "../../../../util/function";
import ReportTable from "../ReportTable";
import { nameExpan } from "../tableHeaders";

const tableHdrs = [
  "vetName",
  "slotsAvailable",
  "slotsBooked",
  "slotsRemaining",
  "overtimetime",
  "utilizationPercentage",
];

const VetsSlotsReport = () => {
  const dispatch = useDispatch();
  const [selectedFilter, setSelectedFilter] = useState("today");
  const [crntTblHeders, setCrntTblHeders] = useState(tableHdrs?.slice(0, 5));
  const [activeTableHeaders, setActiveTableHeaders] = useState(
    tableHdrs?.slice(0, 5)?.map((pd, i) => ({ name: pd, isSelected: true, i })),
  );
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const { vetSlots } = useSelector((state) => state?.report);
  const rowsPerPage = 10;

  useEffect(() => {
    onApiCall(1, selectedFilter);
  }, [dispatch, selectedFilter]);

  const onApiCall = (pge = 1, filter = null) => {
    setPage(pge);
    const reqFilter = filter ? filter : selectedFilter;
    const reqObj = {
      type: "slots",
      filter: reqFilter,
      page: pge,
      itemSize: rowsPerPage,
    };
    dispatch(getVetsSlotsReportData(reqObj));
  };

  const handleEditColumn = () => {
    const reqList = tableHdrs?.map((pd, i) => {
      const isObjMat = activeTableHeaders?.find(
        (tblHdr) => tblHdr?.name === pd,
      );
      return { name: pd, isSelected: isObjMat?.isSelected ?? false, i };
    });
    setActiveTableHeaders(reqList);
    setEditColModVsble(true);
  };

  const onEditModClose = () => {
    setEditColModVsble(false);
  };

  const handleSelcetdColumn = (selected, ind) => {
    const reqList = activeTableHeaders?.map((act, i) => {
      if (i === ind) return { ...act, isSelected: selected };
      return act;
    });
    setActiveTableHeaders(reqList);
  };

  const handleSaveTableColumn = () => {
    const reqList = activeTableHeaders
      ?.filter((act) => act?.isSelected)
      ?.map((act) => {
        return act?.name;
      });
    setCrntTblHeders(reqList);
    setEditColModVsble(false);
  };

  const totalPage = Math.ceil((vetSlots?.totalRecords ?? 0) / rowsPerPage);

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  return (
    <>
      <div className="flex-row-ali-cen mt5 mh20">
        <Typography className="font-medium fs12 gray28 ml10">
          Number of Records: {vetSlots?.totalRecords ?? 0}
        </Typography>
        <div
          className="flex-row-ali-cen ml20 cursor"
          onClick={handleEditColumn}
        >
          <EditOutlinedIcon sx={w20h20BlueIcon} />
          <Typography className="blue-color fs16 font-medium ml5">
            Edit columns ({crntTblHeders?.length})
          </Typography>
        </div>
        <div className="flex-row-ali-cen ml20 cursor" onClick={handleOpenChart}>
          <AutoGraphIcon sx={w20h20BlueIcon} />
        </div>
        <div className="flex1-end">
          <div className="w15Per">
            <CustomSelect
              list={[
                { name: "Today", value: "today" },
                { name: "Week", value: "week" },
              ]}
              value={selectedFilter}
              handleChange={(e) => setSelectedFilter(e?.target?.value)}
              name="selectedFilter"
              label=""
              select
            />
          </div>
        </div>
      </div>
      <div className="mtMin10">
        <ReportTable
          datas={(vetSlots?.data ?? [])?.map((li) => ({
            ...li,
            overtimetime:
              (li?.overtimetime ?? "")?.toString()?.length > 0
                ? minutesToHours(li?.overtimetime)
                : "",
          }))}
          columns={crntTblHeders}
          maxHeight="60vh"
        />
        <div className="flex1-end mtMin30">
          {Math.ceil((vetSlots?.totalRecords ?? 0) / rowsPerPage) > 1 ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12}>
                  <div className="flex1-end">
                    <Pagination
                      count={totalPage}
                      variant="outlined"
                      color="primary"
                      page={page}
                      onChange={handleChangePage}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </div>
      </div>

      <CustomModal
        open={editColModVsble}
        onClose={onEditModClose}
        header="Columns"
        modal
        modalWidth={25}
      >
        <div className="ph20 scroll-70vh">
          {activeTableHeaders?.map((hr) => (
            <div className="flex-row" key={hr?.i}>
              <CustomCheckbox
                label={nameExpan?.[hr?.name]}
                checked={hr?.isSelected}
                onChange={() => handleSelcetdColumn(!hr?.isSelected, hr?.i)}
              />
            </div>
          ))}
          <div className="flex-end mb10">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={handleSaveTableColumn}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default VetsSlotsReport;
